export default __webpack_public_path__ + "b61979b985cf89f72d8c08ea8a9a920e.ttf";